import axios from "axios";

export function loadFields(wizardId) {
    return axios.get(`/api/wizard/getfields/${wizardId}`)
        .then(response => ({ response }))
        .catch(error => ({ error }));
}